"use client";
import { DefaultAudioSkin } from "../../internal/skins/default-audio/skin.js";
import { jsx } from "react/jsx-runtime";
//#region src/presets/audio/skin.tsx
function AudioSkin(props) {
	return /* @__PURE__ */ jsx(DefaultAudioSkin, { ...props });
}
//#endregion
export { AudioSkin };

//# sourceMappingURL=skin.js.map